/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ConfirmedInputs */

const cs_enum_confirmed = /** @type {(inputs: Enum_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrzeno`)
};

const en_enum_confirmed = /** @type {(inputs: Enum_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed`)
};

/**
* | output |
* | --- |
* | "Confirmed" |
*
* @param {Enum_ConfirmedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_confirmed = /** @type {((inputs?: Enum_ConfirmedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ConfirmedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_confirmed(inputs)
	return cs_enum_confirmed(inputs)
});